import { render } from "./ClassifiedList.vue?vue&type=template&id=88529456"
import script from "./ClassifiedList.vue?vue&type=script&lang=js"
export * from "./ClassifiedList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__